'use client';

import Link from 'next/link';
import { Instagram, Music } from 'lucide-react';

interface FooterProps {
  onTruckClick?: () => void;
  onSocialClick?: (platform: string) => void;
}

export default function Footer({ onTruckClick, onSocialClick }: FooterProps) {
  const handleTruckClick = () => {
    if (onTruckClick) {
      onTruckClick();
    } else {
      const messages = [
        'VROOM VROOM! Driving into adventure! 🚛📚',
        'Let\'s cruise through stories of courage! ❤️✨',
        'Rolling into our story library! 🎆📚',
        'Faith-friendly fun for the whole family! 👨‍👩‍👧‍👦✨',
        'Big adventures for little learners! 🎆👶',
        'Join the Monster Truck Stories family! 🚛❤️',
        'Beep beep! Story time is on! 🚛📖'
      ];
      
      const randomMessage = messages[Math.floor(Math.random() * messages.length)];
      alert(randomMessage);
    }
  };

  const handleSocialClick = (platform: string) => {
    if (onSocialClick) {
      onSocialClick(platform);
    } else {
      if (platform === 'instagram') {
        window.open('https://www.instagram.com/monstertruckstories/', '_blank');
      } else if (platform === 'tiktok') {
        window.open('https://www.tiktok.com/@monstertruckstories', '_blank');
      }
    }
  };

  return (
    <footer className="footer bg-gradient-to-br from-teal-400 to-emerald-400 py-12 text-white">
      <div className="footer-container max-w-7xl mx-auto px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div className="footer-section flex items-center gap-4">
            <img 
              src="/assets/Captain Monster Truck 1-Photoroom.png" 
              alt="Captain Monster Truck" 
              className="w-15 h-15 object-contain cursor-pointer hover:scale-105 transition-transform"
              onClick={handleTruckClick}
            />
            <div className="font-bungee text-xl font-bold">
              CAPTAIN MONSTER
            </div>
          </div>
          
          <div className="footer-section">
            <h3 className="text-lg font-bold mb-4">Navigation</h3>
            <div className="space-y-2">
              <Link href="/#about" className="block opacity-90 hover:opacity-100 transition-opacity">About</Link>
              <Link href="/#features" className="block opacity-90 hover:opacity-100 transition-opacity">Features</Link>
              <Link href="/#pricing" className="block opacity-90 hover:opacity-100 transition-opacity">Pricing</Link>
              <Link href="/login" className="block opacity-90 hover:opacity-100 transition-opacity">Login</Link>
              <Link href="/contact" className="block opacity-90 hover:opacity-100 transition-opacity">Contact Us</Link>
            </div>
          </div>
          
          <div className="footer-section">
            <h3 className="text-lg font-bold mb-4">Follow Us</h3>
            <div className="space-y-2">
              <button
                onClick={() => handleSocialClick('instagram')}
                className="flex items-center gap-2 opacity-90 hover:opacity-100 transition-opacity cursor-pointer"
              >
                <Instagram className="w-4 h-4" />
                Instagram
              </button>
              <button
                onClick={() => handleSocialClick('tiktok')}
                className="flex items-center gap-2 opacity-90 hover:opacity-100 transition-opacity cursor-pointer"
              >
                <Music className="w-4 h-4" />
                TikTok
              </button>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom text-center pt-8 border-t border-white/20 opacity-80">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-4">
            <Link href="/terms" className="text-white/80 hover:text-white transition-colors">
              Terms & Conditions
            </Link>
            <Link href="/privacy" className="text-white/80 hover:text-white transition-colors">
              Privacy Policy
            </Link>
          </div>
          <p>Copyright © 2024 Captain Monster Truck. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
